const CalendarIcons = () => {
	return (
		<svg
            className="inline ml-2"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M3.66634 0.333252C4.03453 0.333252 4.33301 0.631729 4.33301 0.999919V1.66659H9.66634V0.999919C9.66634 0.631729 9.96482 0.333252 10.333 0.333252C10.7012 0.333252 10.9997 0.631729 10.9997 0.999919V1.66659H11.6663C12.7709 1.66659 13.6663 2.56202 13.6663 3.66659V11.6666C13.6663 12.7712 12.7709 13.6666 11.6663 13.6666H2.33301C1.22844 13.6666 0.333008 12.7712 0.333008 11.6666V3.66659C0.333008 2.56202 1.22844 1.66659 2.33301 1.66659H2.99967V0.999919C2.99967 0.631729 3.29815 0.333252 3.66634 0.333252ZM9.66634 2.99992V3.66659C9.66634 4.03478 9.96482 4.33325 10.333 4.33325C10.7012 4.33325 10.9997 4.03478 10.9997 3.66659V2.99992H11.6663C12.0345 2.99992 12.333 3.2984 12.333 3.66659V5.66659H1.66634V3.66659C1.66634 3.2984 1.96482 2.99992 2.33301 2.99992H2.99967V3.66659C2.99967 4.03478 3.29815 4.33325 3.66634 4.33325C4.03453 4.33325 4.33301 4.03478 4.33301 3.66659V2.99992H9.66634ZM1.66634 6.99992V11.6666C1.66634 12.0348 1.96482 12.3333 2.33301 12.3333H11.6663C12.0345 12.3333 12.333 12.0348 12.333 11.6666V6.99992H1.66634Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default CalendarIcons;
